module.exports = __webpack_public_path__ + "img/hk.e7d84d3a.png";